import { render, staticRenderFns } from "./CommentReplies.vue?vue&type=template&id=3fee6e8e"
import script from "./CommentReplies.vue?vue&type=script&lang=js"
export * from "./CommentReplies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports